module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ModalTheme', {
    attrs: {
      "with-content": true,
      "theme": true,
      "fix-height": false
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('template', {
    slot: "main"
  }, [(_vm.loading) ? _c('loader', {
    attrs: {
      "loading": true
    }
  }) : _vm._e(), _vm._v(" "), _c('TextInputBloc', {
    attrs: {
      "label": 'Name',
      "required": true,
      "validator": _vm.FORM_VALIDATORS.name,
      "max-length": 40
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('TextInputBloc', {
    attrs: {
      "label": 'Reference',
      "required": true,
      "validator": _vm.FORM_VALIDATORS.name,
      "max-length": 40
    },
    model: {
      value: (_vm.reference),
      callback: function($$v) {
        _vm.reference = $$v
      },
      expression: "reference"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('ClientColorButton', {
    attrs: {
      "disabled": !_vm.canSubmit
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Create")])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3047ed26","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/elements/DuplicationModal.vue
// module id = 3107
// module chunks = 0